<template>
    <el-select
      v-model="value"
      @change="changeDateFormatData"
      style="width: 120px"
    >
      <el-option
        v-for="item in dateFormatOptions"
        :key="item.dateFormatId"
        :label="item.label"
        :value="item.dateFormatId"
      >
      </el-option>
    </el-select>
  </template>
  
  <script>
  export default {
    props:["isMonthly"],
    data () {
      return {
        dateFormatOptions: [
            {
              dateFormatId: 2,
              label: '正常显示'
            },
          {
            dateFormatId: 1,
            label: '按时显示'
          },
        ],
        value: 2
      }
    },
    created(){
    },
    methods: {
      changeDateFormatData () {
        this.$emit('changeDateFormatData', { dateFormatId: this.value })
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  